module.exports = __webpack_public_path__ + "static/media/checkout-local-delivery.0c3ea1f8.svg";